import { Component } from '@angular/core';
import { AuthService } from '../../Services/auth.service';

@Component({
  selector: 'app-combine-nav-mobile',
  standalone: false,
  templateUrl: './combine-nav-mobile.component.html',
  styleUrl: './combine-nav-mobile.component.css'
})
export class CombineNavMobileComponent {

  menuItems = [
    { path: "EmailDevelery", label: "notificationSettings", icon: "🔗" },
    { path: "Noitifications", label: "notifications", icon: "🔔" },
    

  ];
  getIcon(path: string): string {
    const iconMap: { [key: string]: string } = {
      "EmailDevelery": "pi  pi-cog text-primary",  
      "Noitifications": "fa-solid fa-bell text-primary", 
    };
    return iconMap[path] || "bi bi-circle"; 
  }
userRole:string
constructor(private auth:AuthService){
    this.userRole=this.auth.getRoles();
}


}
